import { isSameDay } from 'date-fns'
import { format } from '@/utils/date-fns'

export function combineDatesToReadableString(
  d1: Date,
  d2: Date,
  showDatesIfNotSameDay = true
): string {
  if (isSameDay(d1, d2) || !showDatesIfNotSameDay) {
    return (
      format(d1, 'dd. MMMM') +
      '\n' +
      format(d1, 'HH:mm') +
      '-' +
      format(d2, 'HH:mm')
    )
  }
  return (format(d1, 'dd.MM HH:mm') +
    '\n -> ' +
    format(d2, 'dd.MM HH:mm')) as string
}
